import React from "react";
import { Col, Row, Button } from "antd";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import { Columns } from "./Components";
import playstore from "../assets/images/playstore.png";
import visa from "../assets/images/visa.png";
import cards from "../assets/images/cards.png";
import https from "../assets/images/https.png";
import { Image } from "../components/Image";
import FooterSocial from "./FooterSocial";
import { Margin } from "@devsplan/wealthclub-ui";
import { useTranslation } from "react-i18next";
import {
  FREQUENTLY_ASKED_QUESTIONS_ROUTE,
  INFO_ROUTE,
  PRIVACY_POLICY,
  REQUEST_CARD_ROUTE,
  TERMS_AND_CONDITIONS,
} from "../shared/constants";

const Container = styled.div`
  padding-top: 64px;
  background-color: #000;
  margin-top: 0px;
`;

const Title = styled.h4`
  text-transform: uppercase;
  font-size: 20px;
  color: #fff;
  line-height: 14px;
  margin: 0;
  margin-bottom: 16px;
`;

const List = styled.ul`
  padding: 0px;
  margin: 0px;
  list-style: none;
`;

const ImageContainer = styled.div`
  background-image: url("/images/bgfooter.png");
  background-size: cover;
  background-position: center center;
  margin-top: 64px;
`;

const ImageContainerBg = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  padding: 50px 0px;
  height: 100%;
`;

const Footer = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Container>
      <Row justify="center" align="middle">
        <Col xs={24} sm={24} md={24} lg={16}>
          <Row justify="center" align="middle" gutter={[0, 32]}>
            <Col xs={20} sm={18} md={{ span: 6, offset: 2 }}>
              <Columns justify="start" align="top">
                <Title>{t("ABOUT US")}</Title>
                <List>
                  <li>
                    <a href="/#">{t("Our Founder")}</a>
                  </li>
                  <li>
                    <a href="/#">{t("Our Platform")}</a>
                  </li>
                  <li>
                    <a href="/">{t("Contact")}</a>
                  </li>
                </List>
              </Columns>
            </Col>
            <Col xs={20} sm={18} md={{ span: 6, offset: 2 }}>
              <Columns justify="start" align="top">
                <Title>{t("ACCESS")}</Title>
                <List>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://wealthclub.pro"
                    >
                      {t("Club")}
                    </a>
                  </li>
                  <li>
                    <Link to={INFO_ROUTE}>{t("Instructions")}</Link>
                  </li>
                  <li>
                    <a href="/#">{t("Leave us your recommendation")}</a>
                  </li>
                </List>
              </Columns>
            </Col>
            <Col xs={20} sm={18} md={{ span: 6, offset: 2 }}>
              <Columns justify="start" align="top">
                <Title>{t("Legal")}</Title>
                <List>
                  <li>
                    <Link to={TERMS_AND_CONDITIONS}>
                      {t("Terms and Conditions")}
                    </Link>
                  </li>
                  <li>
                    <Link to={PRIVACY_POLICY}>{t("Privacy Policy")}</Link>
                  </li>
                  <li>
                    <Link to={FREQUENTLY_ASKED_QUESTIONS_ROUTE}>
                      {t("Frequently Asked Questions")}
                    </Link>
                  </li>
                </List>
              </Columns>
            </Col>
          </Row>
        </Col>
      </Row>
      <ImageContainer>
        <ImageContainerBg>
          <Row justify="center" gutter={[0, 32]}>
            <Col xs={24} sm={24} md={24} lg={12} xl={8}>
              <Columns justify="center" align="middle">
                <Title>{t("DOWNLOAD OUR APP")}</Title>
                <p>{t("Coming soon")}</p>
                <Image src={playstore} width="230px" height="68px" />
              </Columns>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={8}>
              <Columns justify="center" align="middle">
                <Title>{t("REQUEST OUR CARD")}</Title>
                <Button
                  type="link"
                  style={{ marginBottom: 16 }}
                  onClick={() => history.push(REQUEST_CARD_ROUTE)}
                  disabled
                >
                  Request Now
                </Button>
                <Image src={visa} width="230px" height="68px" />
              </Columns>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={8}>
              <Columns justify="center" align="middle">
                <Title>{t("CONNECT WITH US")}</Title>
                <Margin top="32px">
                  <FooterSocial />
                </Margin>
              </Columns>
            </Col>
          </Row>
        </ImageContainerBg>
      </ImageContainer>
      <Row
        justify="center"
        align="middle"
        style={{ marginTop: 64, marginBottom: 64 }}
      >
        <Col xs={16}>
          <Columns justify="center" align="middle">
            <p>{t("Mail")} info@wealthclub.pro</p>
            <p>WealthClub.Pro | 2020 © {t("All rights reserved")}</p>
            <p>
              {t("Version")} <span>{process.env.REACT_APP_VERSION}</span>
            </p>
            <p>
              <Image src={https} width="64px" height="64px" />
            </p>
            <p>
              <Image src={cards} width="210px" height="32px" />
            </p>
          </Columns>
          <div>
            <p style={{ textAlign: "justify" }}>
              {t("DISCLAIMER OF EARNINGS")}
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
